// import React, { FormEvent, useEffect, useState } from 'react'
// import { Button, Form, Modal } from 'react-bootstrap'
// import { getAllRegions } from '../../../../services/userServices/UserInfoService';
// import Region, { CreateTeamRequest } from '../../../../interfaces/identity/Region';
// import { toast } from 'react-toastify';
// import { useAuth } from '../../../../firebase/AuthProvider';
// import { CreateTeamAsync } from '../../../../services/teamandregion/TeamandRegionService';
// import Loader from '../../loader/Loader';
// interface AddTeamModalProps {
//     showAddTeameModal: boolean;
//     handleCloseAddTeamModal: () => void;
//     RefreshListOfTeam: () => void;
// }
// const AddTeamModal: React.FC<AddTeamModalProps> = ({
//     handleCloseAddTeamModal,
//     showAddTeameModal,
//     RefreshListOfTeam,
// }) => {
//     const { currentUser } = useAuth();
//     // data
//     const [regionList, setRegionList] = useState<Region[]>([]);
//     const [teamForm, setTeamForm] = useState<CreateTeamRequest>({
//         teamName: "",
//         regionId: 0,
//     });

//     //other
//     const [validated, setValidated] = useState<boolean>(false);
//     const [IsLoading, setIsLoading] = useState<boolean>(false);

//     useEffect(() => {
//         GetAllRegions()
//     }, [currentUser])

//     const GetAllRegions = async () => {
//         const token = await currentUser?.getIdToken();
//         if (!token) return;
//         getAllRegions(token).then((res) => {
//             if (res.success) {
//                 setRegionList(res.data);
//             } else {
//                 toast.error(res.message);
//             }
//         }).catch((err) => {
//             toast.error(err.message);
//         })
//     }

//     const handleSubmitAddTeamForm = async (e: FormEvent<HTMLFormElement>) => {
//         e.preventDefault();
//         const form = e.currentTarget;
//         // Cheking validation form
//         if (form.checkValidity() === false) {
//             setValidated(true);
//             return;
//         }
//         const token = await currentUser?.getIdToken();
//         if (!token) return;

//         setIsLoading(true);
//         CreateTeamAsync(token, teamForm).then((res) => {
//             if (res.success) {
//                 toast.success("Team Created Successfully");
//                 RefreshListOfTeam();
//                 handleCloseAddTeamModal();
//             } else {
//                 toast.error(res.message);
//             }
//         }).catch((err) => {
//             toast.error(err.message);
//         }).finally(()=>{
//             setIsLoading(false);
//         })

//     }

//     // for text inputs
//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const { name, value } = e.target;
//         setTeamForm((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     // for selects
//     const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//         const { name, value } = e.target;
//         setTeamForm((prev) => ({
//             ...prev,
//             [name]: Number(value), // regionId must be number
//         }));
//     };

//     return (
//         <>
//             {IsLoading && <Loader />}
//             <Modal
//                 show={showAddTeameModal}
//                 onHide={handleCloseAddTeamModal}
//                 className="custom_popup"
//                 centered
//             >
//                 <Form onSubmit={handleSubmitAddTeamForm} noValidate validated={validated}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>
//                             Add New Team
//                         </Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <Form.Group className="custom_input_flled mb-0">
//                             <Form.Label>Enter Team Name</Form.Label>
//                             <Form.Control
//                                 required
//                                 name="teamName"
//                                 value={teamForm.teamName}
//                                 onChange={handleInputChange}
//                                 type="text"
//                                 placeholder="Enter new team name"
//                             />
//                             <Form.Control.Feedback type="invalid">
//                                 Please Enter the Name of Team
//                             </Form.Control.Feedback>
//                         </Form.Group>

//                         <Form.Group className="custom_input_flled mt-3">
//                             <Form.Label>Select Region</Form.Label>
//                             <Form.Select
//                                 required
//                                 name="regionId"
//                                 value={teamForm.regionId || ""}
//                                 onChange={handleSelectChange}
//                             >
//                                 <option value="">-- Select Region --</option>
//                                 {regionList.map((region) => (
//                                     <option key={region.regionId} value={region.regionId}>
//                                         {region.regionName}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                             <Form.Control.Feedback type="invalid">
//                                 Please Select the Region
//                             </Form.Control.Feedback>
//                         </Form.Group>

//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button
//                             variant="secondary"
//                             onClick={handleCloseAddTeamModal}
//                         >
//                             Close
//                         </Button>
//                         <Button variant="primary" type='submit'>
//                             Add Team
//                         </Button>
//                     </Modal.Footer>
//                 </Form>
//             </Modal>
//         </>
//     )
// }

// export default AddTeamModal

import React, { FormEvent, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../../../../firebase/AuthProvider";
import { getAllRegions } from "../../../../services/userServices/UserInfoService";
import Region, {
  CreateTeamRequest,
} from "../../../../interfaces/identity/Region";
import { CreateTeamAsync, UpdateTeamAsync } from "../../../../services/teamandregion/TeamandRegionService";
import Loader from "../../loader/Loader";
import { ChevronDown } from "lucide-react";
import { AllTeams } from "../../../../interfaces/identity/calendar/Events";

interface AddTeamModalProps {
  showAddTeameModal: boolean;
  handleCloseAddTeamModal: () => void;
  RefreshListOfTeam: () => void;
  editTeam?: AllTeams | null;
}

const AddTeamModal: React.FC<AddTeamModalProps> = ({
  handleCloseAddTeamModal,
  showAddTeameModal,
  RefreshListOfTeam,
  editTeam,
}) => {
  const { currentUser } = useAuth();

  // data
  const [regionList, setRegionList] = useState<Region[]>([]);
  const [teamForm, setTeamForm] = useState<CreateTeamRequest>({
    teamName: "",
    regionId: 0,
  });

  //other
  const [validated, setValidated] = useState<boolean>(false);
  const [IsLoading, setIsLoading] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [errors, setErrors] = useState({ teamName: false, regionId: false });

  const isEditMode = !!editTeam;

  useEffect(() => {
    GetAllRegions();
  }, [currentUser]);

  // Load team data when in edit mode
  useEffect(() => {
    if (editTeam && showAddTeameModal) {
      setTeamForm({
        teamName: editTeam.teamName,
        regionId: editTeam.regionId,
      });
    } else if (!editTeam && showAddTeameModal) {
      // Reset form when opening in add mode
      setTeamForm({ teamName: "", regionId: 0 });
      setValidated(false);
      setErrors({ teamName: false, regionId: false });
    }
  }, [editTeam, showAddTeameModal]);

  const GetAllRegions = async () => {
    const token = await currentUser?.getIdToken();
    if (!token) return;
    getAllRegions(token)
      .then((res) => {
        if (res.success) {
          setRegionList(res.data);
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const handleSubmitAddTeamForm = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Manual validation
    const newErrors = {
      teamName: !teamForm.teamName.trim(),
      regionId: !teamForm.regionId || teamForm.regionId === 0,
    };

    setErrors(newErrors);

    if (newErrors.teamName || newErrors.regionId) {
      setValidated(true);
      return;
    }

    const token = await currentUser?.getIdToken();
    if (!token) return;

    setIsLoading(true);
    
    if (isEditMode && editTeam) {
      // Update existing team
      UpdateTeamAsync(token, editTeam.id, teamForm)
        .then((res) => {
          if (res.success) {
            toast.success("Team Updated Successfully");
            RefreshListOfTeam();
            handleCloseAddTeamModal();
            // Reset form
            setTeamForm({ teamName: "", regionId: 0 });
            setValidated(false);
            setErrors({ teamName: false, regionId: false });
          } else {
            toast.error(res.message);
          }
        })
        .catch((err) => {
          // toast.error(err.message);
          // toast.error("Edit api Missing...!!");
          return;
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      // Create new team
      CreateTeamAsync(token, teamForm)
        .then((res) => {
          if (res.success) {
            toast.success("Team Created Successfully");
            RefreshListOfTeam();
            handleCloseAddTeamModal();
            // Reset form
            setTeamForm({ teamName: "", regionId: 0 });
            setValidated(false);
            setErrors({ teamName: false, regionId: false });
          } else {
            toast.error(res.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  // for text inputs
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setTeamForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (validated) {
      setErrors((prev) => ({ ...prev, teamName: !value.trim() }));
    }
  };

  // for region selection
  const handleRegionSelect = (regionId: number) => {
    setTeamForm((prev) => ({
      ...prev,
      regionId: regionId,
    }));
    setIsDropdownOpen(false);
    if (validated) {
      setErrors((prev) => ({ ...prev, regionId: !regionId || regionId === 0 }));
    }
  };

  const getSelectedRegionName = () => {
    const selected = regionList.find((r) => r.regionId === teamForm.regionId);
    return selected ? selected.regionName : "";
  };

  if (!showAddTeameModal) return null;

  return (
    <>
      {IsLoading && <Loader />}
      <div
        className="fixed inset-0 z-[100] p-4 flex items-center justify-center bg-black bg-opacity-50"
        onClick={handleCloseAddTeamModal}
      >
        <div
          className="relative w-full max-w-[28rem] rounded-2xl bg-white  shadow-xl"
          onClick={(e) => e.stopPropagation()}
        >
          <form onSubmit={handleSubmitAddTeamForm} noValidate>
            {/* Modal title */}
            <h2 className="text-xl pt-4 px-6 pb-3 border-b border-[#E5E7EB] text-[#0A0A0A] font-poppins font-bold">
              {isEditMode ? "Edit Team" : "Add New Team"}
            </h2>

            {/* Team Name Input */}
            <div className="px-6 pt-2">
              <label className="block text-[#0A0A0A] font-poppins text-base font-normal mb-2">
                {isEditMode ? "Team Name" : "Enter Team Name"}
              </label>
              <input
                type="text"
                name="teamName"
                placeholder="Enter new team name"
                value={teamForm.teamName}
                onChange={handleInputChange}
                className={`w-full px-4 py-2.5 bg-white border ${
                  validated && errors.teamName
                    ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                    : "border-[#D1D5DC] focus:border-[#717182] focus:ring-[#717182]"
                } rounded-[0.625rem] text-base text-[#0A0A0A] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-1`}
              />
              {validated && errors.teamName && (
                <p className="text-red-500 text-xs mt-1">
                  Please Enter the Name of Team
                </p>
              )}
            </div>

            {/* Region Dropdown */}
            <div className="px-6 pt-3 pb-4">
              <label className="block text-[#0A0A0A] font-poppins text-base font-normal mb-2">
                {isEditMode ? "Region" : "Select Region"}
              </label>
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className={`w-full px-4 py-2.5 bg-white border ${
                    validated && errors.regionId
                      ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                      : "border-[#D1D5DC] focus:border-[#717182] focus:ring-[#717182]"
                  } rounded-[0.625rem] font-poppins text-base text-left flex items-center justify-between focus:outline-none focus:ring-1`}
                >
                  <span
                    className={
                      getSelectedRegionName()
                        ? "text-[#0A0A0A]"
                        : "text-[#9CA3AF]"
                    }
                  >
                    {getSelectedRegionName() || "Select region"}
                  </span>
                  <ChevronDown size={16} className="text-[#6B7280]" />
                </button>

                {isDropdownOpen && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto z-10">
                    {regionList.map((region) => (
                      <div
                        key={region.regionId}
                        onClick={() => handleRegionSelect(region.regionId)}
                        className="px-4 font-poppins py-2.5 text-sm text-[#717182] hover:bg-gray-50 cursor-pointer"
                      >
                        {region.regionName}
                      </div>
                    ))}
                  </div>
                )}

                {validated && errors.regionId && (
                  <p className="text-red-500 text-xs mt-1">
                    Please Select the Region
                  </p>
                )}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end items-center gap-3 pt-3 pr-6 pb-3 border-t border-[#E5E7EB]">
              <button
                type="button"
                onClick={handleCloseAddTeamModal}
                className="px-4 py-2 text-base font-poppins font-normal text-[#7E57C2] hover:bg-gray-50 bg-[#F3F4F6] transition-colors rounded-[0.625rem]"
              >
                Close
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-[#7E57C2] font-poppins text-white text-base font-normal rounded-[0.625rem] hover:bg-[#6D4CAB] transition-colors"
              >
                {isEditMode ? "Update Team" : "Add Team"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddTeamModal;
